<template>
    <div class="app_main">
        <div class="tac_left">
            <Sidemenu></Sidemenu>
        </div>
        <div class="tac_right">
            <div class="tac_right_top">
                <Navigation></Navigation>
            </div>
            <div class="tac_right_main">
                <router-view/>
            </div>
            <!--            <el-tabs-->
            <!--                v-model="editableTabsValue"-->
            <!--                type="card"-->
            <!--                closable-->
            <!--                @tab-remove="removeTab"-->
            <!--            >-->
            <!--                <el-tab-pane-->
            <!--                    v-for="item in editableTabs"-->
            <!--                    :key="item.name"-->
            <!--                    :label="item.title"-->
            <!--                    :name="item.name"-->
            <!--                >-->
            <!--                    <div class="tac_right_main">-->
            <!--                        <router-view />-->
            <!--                    </div>-->
            <!--                </el-tab-pane>-->
            <!--            </el-tabs>-->
        </div>
    </div>


    <!-- 叫号面板 -->
    <div class="call_number_body flex_c_col">
        <div class="call_number_top flex_c_between">
            <div class="call_num_point_div flex_c_col">
                <div class="call_num_line"></div>
            </div>
            <div class="call_num_point_div flex_c_col">
                <div class="call_num_line"></div>
            </div>
        </div>
        <div :class="isOpenCallNumber ? 'call_number_body_expand flex_t_col': 'call_num_panel flex_t_col'">
            <div class="call_num_panel_line flex_c_between" @click="expandDiv">
                <span class="font_16 font_weight font_white">叫号面板</span>
                <span class="font_16 font_weight font_white" v-if="!isOpenCallNumber"><el-icon><UserFilled /></el-icon></span>
                <span class="font_16 font_weight font_white" v-if="isOpenCallNumber"><el-icon><ArrowDownBold /></el-icon></span>
            </div>
            <div class="call_detail flex_t_col" v-if="isOpenCallNumber">
                <!--叫号统计 -->
                <div class="call_statistics flex_c_between">
                    <div class="call_statistics_body flex_center">
                        <div :class="callNumberTab === 'wait' ? 'call_statistics_con call_statistics_act flex_c_col':'call_statistics_con flex_c_col'" @click="changeQuickPanelTab('wait')">
                            <div class="call_statistics_num flex_center">{{ waitCnt }}</div>
                            <div class="call_statistics_label flex_center">待就诊</div>
                        </div>
                    </div>
                    <div class="call_statistics_body flex_center">
                        <div :class="callNumberTab === 'jump' ? 'call_statistics_con call_statistics_act flex_c_col':'call_statistics_con flex_c_col'" @click="changeQuickPanelTab('jump')">
                            <div class="call_statistics_num flex_center">{{ jumpCnt }}</div>
                            <div class="call_statistics_label flex_center">已过号</div>
                        </div>
                    </div>
                </div>
                <!--正在就诊 -->
                <div class="call_callperson flex_c_left">正在就诊：<span class="callperson_name mrl10">{{ callingName }}</span></div>
                <!--待就诊 -->
                <div class="call_wait flex_t_between">
                    <div class="call_wait_title flex_center">等待就诊：</div>
                    <div class="call_wait_con flex_t_col">
                        <div class="call_wait_line flex_c_between" v-for="(item, index) in callNumberList" :key="index">
                            <div>{{ item.cardPatientName }}</div>
                            <div class="flex_c_right">
                                <el-button
                                    type="primary"
                                    size="small"
                                    @click="calling(item)"
                                    :disabled="item.countdown > 0">
                                    {{ item.countdown > 0 ? `叫号（${item.countdown}秒）` : '叫号' }}
                                </el-button>
<!--                                <el-button type="primary" size="small" @click="calling(item)">叫号</el-button>-->
                                <el-button type="success" size="small" @click="callToOrder(item)">接诊</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 提示信息 -->
                <div class="warning_text flex_center">如果需要查询更多信息，请到“<span class="jump_link" @click="changeData('consultationcall')">叫号问诊</span>”进行查询</div>
            </div>
        </div>
    </div>
</template>
<script>
import Navigation from "@/components/navigation";
import Sidemenu from "@/components/sidemenu";
import {docCallAccptNumber, docCallNumber, getQuickPanelData} from "@/api";
import {message, getTodayDate, messageHtml} from "@/assets/utils/common";

export default {
    components: {
        Sidemenu,
        Navigation,
    },
    data() {
        return {
            navselected: 'home',
            editableTabsValue: '1',
            editableTabs: [],
            tabIndex: 1,
            isOpenCallNumber: false,
            waitCnt: 0,
            jumpCnt: 0,
            callCnt: 0,
            waitingList: [],
            jumpList: [],
            callingList: [],
            callingName: null,
            callNumberTab: 'wait',
            callNumberList: [],
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
            countdown: 0, // 倒计时字段
            isCounting: false, // 是否正在倒计时
        }
    },
    created() {
        // this.getQuickPanelDataInfo(); // 叫号快捷面板查询
    },
    mounted() {
        this.navselected = this.$route.name;
        this.addTab("工作台");
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
            this.isOpenCallNumber = false;
        },
        getNavType() {
            this.navselected = this.$store.state.adminleftnavnum;
            console.log(this.navselected)
        },
        getCurrentRouteTitle() {
            console.log(this.$store.state.actRouterTitle);
            let actRouterTitle = this.$store.state.actRouterTitle;
            if (actRouterTitle !== '工作台' && this.navselected !== 'home') {
                // this.addTab(actRouterTitle);
            }
        },

        addTab(actRouterTitle) {
            ++this.tabIndex;
            this.editableTabs.push({
                title: actRouterTitle,
                name: actRouterTitle,
                content: '',
            })
            this.editableTabsValue = actRouterTitle;
        },
        removeTab(targetName) {
            let tabs = this.editableTabs
            let activeName = this.editableTabsValue
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.name === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1]
                        if (nextTab) {
                            activeName = nextTab.name
                        }
                    }
                })
            }

            this.editableTabsValue = activeName
            this.editableTabs = tabs.filter((tab) => tab.name !== targetName)
        },

        // 叫号面板展开收起
        expandDiv() {
            this.isOpenCallNumber = !this.isOpenCallNumber;
            if (this.isOpenCallNumber) {
                this.getQuickPanelDataInfo();
            }
        },

        // 叫号快捷面板查询
        getQuickPanelDataInfo: function () {
            const data = {
                schDate: getTodayDate()
            };
            getQuickPanelData(data).then(res => {
                console.log("getQuickPanelData >>>> " + JSON.stringify(res));
                let rdata = res.data;
                if (rdata.code === 200) {
                    // message( "叫号快捷面板查询",  "success");
                    this.waitCnt = rdata.data.waitCnt;
                    this.jumpCnt = rdata.data.jumpCnt;
                    this.callCnt = rdata.data.callCnt;
                    this.waitingList = rdata.data.waitingList;
                    this.jumpList = rdata.data.jumpList;
                    this.callingList = rdata.data.callingList;
                    this.changeQuickPanelTab('wait');
                    if (this.callingList.length > 0) {
                        this.callingName = this.callingList[0].cardPatientName;
                    }
                }
            }).catch(error => {
                message(error, "error");
            });
        },

        // 切换tab
        changeQuickPanelTab(type) {
            this.callNumberTab = type;
            this.callNumberList = [];
            if (type === 'wait') {
                if (this.waitingList.length > 5) {
                    this.callNumberList = this.waitingList.slice(0, 5);
                } else {
                    this.callNumberList = this.waitingList;
                }
            } else if (type === 'jump') {
                if (this.jumpList.length > 5) {
                    this.callNumberList = this.jumpList.slice(0, 5);
                } else {
                    this.callNumberList = this.jumpList;
                }
            }

            // 初始化每个条目的 countdown 字段
            this.callNumberList = this.callNumberList.map(item => ({
                ...item,
                countdown: 0
            }));
        },


        // 叫号
        calling(row) {
            console.log(row);
            if (row.countdown > 0) return; // 如果正在倒计时，阻止重复点击
            this.startCountdown(row); // 启动倒计时
            let cardPatientName = row.cardPatientName;
            docCallNumber(cardPatientName).then(res => {
                console.log(res);
                if (res.code === 200) {
                    messageHtml("正在呼叫 <span class='font_orange font_18 mrlr10'>"+cardPatientName+"</span> 前往诊室就诊", "success");
                }
            });
        },

        // 启动倒计时
        startCountdown(item) {
            item.countdown = 15;

            const timer = setInterval(() => {
                item.countdown--;

                if (item.countdown <= 0) {
                    clearInterval(timer);
                }
            }, 1000);
        },


        // 接诊
        callToOrder(row) {
            console.log(row);
            this.patientInfo.name = row.cardPatientName;
            this.patientInfo.sex = row.cardPatientSex;
            this.patientInfo.phoneNumber = row.cardPatientPhone;
            this.patientInfo.identity = row.cardIdentity;
            let reId = row.reId;
            console.log(reId)
            docCallAccptNumber(reId).then(res => {
                console.log(res);
                if (res.code === 200) {
                    this.isOpenCallNumber = false;
                    // 叫号成功后，跳到接诊页面
                    window.sessionStorage.removeItem("reservationPatient");
                    window.sessionStorage.setItem("reservationPatient", JSON.stringify(this.patientInfo));

                    this.$router.push({path: '/admin/clinictreat'});
                    this.$store.state.adminleftnavnum = 'clinictreat'; //设置左侧导航2-2 active
                }
            });
        },

    },
    watch: {
        // 监测store.state
        '$store.state.adminleftnavnum': 'getNavType',
        '$store.state.actRouterTitle': 'getCurrentRouteTitle'
    }
}
</script>


<style scoped lang="scss">
    @import "@/assets/styles/admin.scss";
</style>
